<template>
    <div
        class="block bg-minplan-beige border-2 border-transparent transition-colors hover:border-minplan-lightgreybeige group/card relative">

        <div class="flex items-stretch text-minplan-blue max-h-36">

            <!-- LEFT CONTENT -->
            <Link :href="route('clients.apartments.show', apartment.uuid)"
                class="flex flex-1 hover:bg-minplan-lightbeige transition-colors">
            <p class="flex w-1/4">
                <img class="w-full h-auto object-cover" :src="apartment.project.image
                    ? route('media.restore', { filename: apartment.project.image })
                    : '/images/noimg.png'" alt="" />
            </p>

            <div class="p-3 md:p-4 w-3/4">
                <span class="truncate md:text-lg inline-block w-full font-bold">
                    {{ apartment.project.name }} -
                    {{ apartment.rooms }} {{ $t("apartments.rooms") }}
                    {{ $t("apartments.apartment") }}
                </span><br />

                <span class="hidden md:inline-block">
                    {{ apartment.project.street }},
                    {{ apartment.project.zip }}
                    {{ apartment.project.city }}
                </span><br />

                <span class="hidden md:inline-block mt-2 text-minplan-darkbeige">
                    {{ $t("apartments.number") }} {{ apartment.number }} |
                    {{ apartment.rooms }} {{ $t("apartments.rooms") }} {{ apartment.floor }} |
                    {{ apartment.area }} &#13217;
                </span>
            </div>
            </Link>

            <!-- RIGHT SIDE -->
            <div class="flex items-center border-l border-white/20">

                <div class="hidden xl:flex items-start px-4 space-x-2">
                    <small class="text-minplan-darkbeige">
                        {{ apartment.project.responsibleCompany }}
                    </small>
                </div>

                <!-- CHAT BUTTON (HIDDEN IF DISABLED) -->
                <Link v-if="!apartment.chat_is_disabled" :href="route('clients.apartments.chat', apartment.uuid)"
                    class="flex flex-col justify-center items-center w-14 xl:w-auto px-2 xl:px-4 hover:bg-blue-50/50 transition-all"
                    title="Open Chat">
                <div class="relative">
                    <ChatIcon
                        class="h-5 w-5 xl:h-6 xl:w-6 text-minplan-darkgreybeige hover:text-blue-500 transition-colors" />

                    <!-- unread badge -->
                    <span v-if="apartment.unread_count"
                        class="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full ring-2 ring-minplan-beige">
                        {{ apartment.unread_count }}
                    </span>
                </div>

                <!-- text only on desktop -->
                <span class="hidden xl:block text-[10px] font-bold text-minplan-darkbeige uppercase mt-1">
                    Chat
                </span>
                </Link>

            </div>

        </div>
    </div>
</template>

<script>
import { UserIcon, ChatIcon } from "@heroicons/vue/outline";
import { Link } from "@inertiajs/inertia-vue3";

export default {
    props: ["apartment"],
    name: "ClientApartmentCard.vue",
    components: { UserIcon, ChatIcon, Link },
};
</script>

<style scoped></style>